export default __webpack_public_path__ + "static/media/66t.da052958.jpg";